import React, { useContext, useState } from "react";
import { BrowserRouter as Router, Link } from "react-router-dom";
import "./logout.css";

const Logout = () => {
  // const state = useContext(DataContext)
  const [isLogin, setIsLogin] = useState(false);

  // // clear localStorage - enable login
  const logOutSubmit = () => {
    localStorage.clear();
    setIsLogin(false);
  };

  return (
    <button className="logoutButton" onClick={logOutSubmit}>
      <Link to={isLogin ? "/" : "/login"}>Logout</Link>
    </button>
  );
};

export default Logout;
